export default __webpack_public_path__ + "static/7-0951f578a889d001ac217a20f2c5d578.jpg";